export default __webpack_public_path__ + "static/media/4.95a84b92.jpg";